/** 组织数据树形结构方法
 */
const orgCtl = {
  /** 查询树形组织机构及列表组织机构【树形结构+列表】
   * @param _this {object} 页面指针
   * @param url {string} 接口地址
   */
  organizationTreeAndList: function (_this, url) {
    _this.$axios({
      method: 'post',
      url: url,
      data: {
      },
      headers: {
        Authorization: sessionStorage.getItem('token')
      }
    }).then(function (res) {
      if (res.data.code === 200) {
        _this.orgLoading = false
        _this.organizeTree = res.data.data.organizationTree
        _this.restaurants = res.data.data.organizationList.map(item => ({
          value: item.orgName,
          orgId: item.orgId
        }))
      } else {
        console.log(res)
      }
    }).catch(err => {
      console.log(err)
    })
  }
}
export default orgCtl



// WEBPACK FOOTER //
// ./src/javascript/function/getOrgTreeFunction.js